import React from "react";
import { Switch } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { LaunchButtonProps } from "../../types";


const useStyles = makeStyles({
  root: {
    width: "70px",
    height: "30px",
    padding: "0px",
    boxShadow: "-5px 3px 20px #00000026",
    borderRadius: "20px"
  },
  switchBase: {
    color: "#fff",
    padding: "3px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#00C6B1"
      }
    }
  },
  thumb: {
    color: "#00C6B1",
    width: "25px",
    height: "25px",
    margin: "-0.3px",
    "&:after": {
      backgroundColor: "white"
    }
  },
  track: {
    borderRadius: "20px",
    backgroundColor: "#FFFFFF",
    opacity: "1 !important",
    "&:after, &:before": {
      paddingTop: "2px",
      fontSize: "7.3px",
      fontWeight: "bolder",
      position: "absolute",
      top: "7px"
    },
    "&:after": {
      color: "#fff",
      content: "'STARTED'",
      left: "5px"
    },
    "&:before": {
      color: "#00C6B1",
      content: "'START'",
      right: "5px"
    }
  },
  checked: {
    color: "#fff !important",
    transform: "translateX(40px) !important"
  }
});

export default function LaunchButton(props: LaunchButtonProps) {
  const classes = useStyles();

  return (
    <div onClick={props.handleToggle}>
      <Switch
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked
        }}
        checked={props.checkedA}
        onChange={props.handleChange}
        name={props.name}
        inputProps={{ "aria-label": "secondary checkbox" }}
      />
    </div>
  );
}
